import styled from 'styled-components';

export const ContentModal = styled.div`

    .ant-modal-label-name{
        font-weight: bold;
    }src

    .ant-space{
        display: flex; 
        margin-bottom: 8px;
        width: 100%;
    }

    .ant-space-item{
        width: 100%;
    }

    .ant-space-item:last-child{
        width: 5%;
    }
`;
export const Container = styled.div`
    padding: 15px 32px;

    .ant-table-tbody > tr > td {
        word-break: break-word;
        white-space: normal;
    }
`;
export const ContentPanelIndex = styled.div`
    background-color: #F8F8F8; 
    height: 100%;
    opacity: 1;
    width: 100%;
    box-shadow: none;

    
    .ant-table-column-sorters > span{
        color: #929292; 
        opacity: 1;
    }

    .ant-tabs-tab {
        margin: 0;
        padding: 0 19px;

        .ant-tabs-tab-btn {
            padding: 12px 0;
            font-weight: 300;
            font-size: 20px;
            color: #929292;
        }
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        font-weight: 500;
        color: #000000;
        text-shadow: 0 0 0.25px currentColor;
    }
    
    .ant-divider-horizontal {
        margin: 15px 0;
        width: 100%;
    }
    
    .formbuilder-card-box{
        background: #FFFFFF;

        .ant-card-head-title{
            letter-spacing: 1.2; 
            font-weight: bold;
            font-size: 18;
        }

        .anticon-setting{
            color: #000000;
        }
    }

    .row-tab-text {
        padding-left: 16px;

        .tab-text{
            font-size: 12px;
            opacity: 1;
        }
    }

    .ant-collapse-box{
        overflow-y: hidden;
    }

    .panel-content {
        letter-spacing: 1.2; 
        font-weight: bold;
    }

    .search-icon {
        font-size: 16px;
        color: #929292;
        opacity: 1;
    }

    .scrollbar-tab-pane{
        width: 300px;
    }

    .collapse-panels{
        margin-top: 20px;
        width: 280px;
    }

    .space-custom-header {
        display: flex;  
        justify-content: space-between;
        width: 300px;
        border: 1px solid blue;
        
        
        .icon-header {
            font-size: 20px;
            color: #929292;
            opacity: 1;
            cursor: pointer;
         }

        .title-header{
            opacity: 1; 
        }
    }

    .more-outlined{
        font-size: 20px;
    }

    .container-space{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .float-left{
        float: left;
    }

    @media only screen and (max-width: 480px) {

        .space-search{
            margin: 2px 0px;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 481px) and (max-width: 630px) {
        .space-search{
            margin: 2px 0px;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 630px) and (max-width: 768px) {
        .space-search{
            margin: 2px 2px;
            width: 220px !important;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 992px) {
        .space-search{
            margin: 2px 2px;
        }
    }

    @media only screen and (min-width: 992px) and (max-width: 1200px) {
        .space-search{
            margin: 2px 2px;
            width: 190px !important;
        }
    }

    @media only screen and (min-width: 1200px) and (max-width: 1600px) {
        .space-search{
            margin: 2px 2px;
            width: 200px !important;
        }
    }

    @media only screen and (min-width: 1600px) and (max-width: 1900px) {
        .space-search{
            margin: 2px 2px;
            width: 230px !important;
        }  
    }

    .space-search{
        margin: 2px 2px;
        width: 250px;
    }

    .pl-15{
        padding-left: 0px !important;
    }

    .ml-15{
        margin-left: 0px !important;
    }

    .table{
        margin-top: 30px;
    }

    .tag-columns{
        width: 96px;
        height: 24px;
        text-align: center;
    }

    .table-footer-legend {
        margin-bottom: 20px;
        text-align: center;
        color: #C52B2B;
        opacity: 1;

        a{
            color: #C52B2B;
        }

    }

`;